import { Outlet } from "react-router-dom";
import ApplicationContainer from "components/application-container/ApplicationContainer";

const ApplicationContainerPage = () => {
    return (
        <ApplicationContainer elementId="application-summary">
            <div className="flex flex-col gap-4 w-full items-center">
                <Outlet />
            </div>
        </ApplicationContainer>
    );
};

export { ApplicationContainerPage };
export default ApplicationContainerPage;
